import React from "react";

export const IconFolder: React.FC<{ className?: string }> = ({ className = "h-10 w-12" }) => (
	<svg
		viewBox="0 0 24 24"
		fill="currentColor"
		aria-hidden="true"
		className={`transition-colors duration-200 ${className}`}
	>
		<path d="M2.25 6.75A2.25 2.25 0 0 1 4.5 4.5h4.379a2.25 2.25 0 0 1 1.59.659l1.22 1.221a2.25 2.25 0 0 0 1.59.659H19.5a2.25 2.25 0 0 1 2.25 2.25v6.75A2.25 2.25 0 0 1 19.5 18H4.5A2.25 2.25 0 0 1 2.25 15.75V6.75z" />
	</svg>
);

export const IconFile: React.FC<{ className?: string }> = ({ className = "h-10 w-10" }) => (
	<svg
		viewBox="0 0 24 24"
		fill="currentColor"
		aria-hidden="true"
		className={`transition-colors duration-200 ${className}`}
	>
		<path d="M6.75 4.5A2.25 2.25 0 0 1 9 2.25h5.379a2.25 2.25 0 0 1 1.59.659l3.122 3.122a2.25 2.25 0 0 1 .659 1.59V19.5A2.25 2.25 0 0 1 17.5 21.75h-8.75A2.25 2.25 0 0 1 6.5 19.5Z" />
		<path d="M14.25 2.25V6a2.25 2.25 0 0 0 2.25 2.25h3.75" opacity="0.35" />
	</svg>
);

export const IconImageStack: React.FC<{ className?: string }> = ({ className = "h-10 w-10" }) => (
	<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
		<path d="M5 5a2 2 0 0 1 2-2h7.172a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 20 8.828V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2Z" opacity="0.4" />
		<path d="M4 8a2 2 0 0 1 2-2h7.172a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 19 11.828V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" />
		<circle cx="9" cy="11" r="1.25" />
		<path d="M6.5 16.5 9.8 13.2a1 1 0 0 1 1.4 0l2.2 2.2 1.4-1.4a1 1 0 0 1 1.4 0L18 16.8" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" />
	</svg>
);

export const IconDocumentStack: React.FC<{ className?: string }> = ({ className = "h-10 w-10" }) => (
	<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
		<path d="M4.5 5A2.5 2.5 0 0 1 7 2.5h6.379a2.5 2.5 0 0 1 1.768.732l4.121 4.121A2.5 2.5 0 0 1 20 9.121V19A2.5 2.5 0 0 1 17.5 21.5H7A2.5 2.5 0 0 1 4.5 19Z" opacity="0.35" />
		<path d="M3 8.5A2.5 2.5 0 0 1 5.5 6H12a2.5 2.5 0 0 1 1.768.732l4.5 4.5A2.5 2.5 0 0 1 19 13v5.5A2.5 2.5 0 0 1 16.5 21h-11A2.5 2.5 0 0 1 3 18.5Z" />
		<path d="M8 12.5h6M8 15.5h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);
